import '~/styles/globals.less'
import type { AppProps } from 'next/app'
import { ApolloProvider } from '@apollo/client'
import { useApollo } from '~/graphqls/apollo/client'
import zhCN from 'antd/lib/locale/zh_CN'
import { ConfigProvider } from 'antd'
import React, { useEffect } from 'react'
import { useInitStore } from '~/stores'
import { Provider as MobXProvider } from 'mobx-react'
import { ThemeProvider } from 'styled-components'
import NProgress from 'nprogress'
import { useRouter } from 'next/router'
import { observer } from 'mobx-react'
import Cookies from 'js-cookie'
import { UserDeviceProvider } from '~/components/business/UserDeviceProvider'
import { CHAPTER_ID_KEY } from '~/configs'

const theme = {
  'neutral-50': '#000',
  'neutral-100': '#141416',
  'neutral-200': '#23262f',
  'neutral-300': '#353945',
  'neutral-400': '#777e90',
  'neutral-500': '#b1b5c4',
  'neutral-600': '#e6e8ec',
  'neutral-700': '#f4f5f6',
  'neutral-800': '#fcfcfd',
  'neutral-900': '#fff',
  primary: '#7851ec',
  error: '#ef466f',
  success: '#45b36b',
  divider1: '#E6E8EC',
  divider2: '#777E91',
}

function MyApp({ Component, pageProps }: AppProps) {
  const apolloClient = useApollo(pageProps)
  const store = useInitStore(pageProps.initialState)
  const router = useRouter()

  useEffect(() => {
    // 文档参考 hooks/useOverrideBackScrollBehavor
    history.scrollRestoration = 'manual'

    router.events?.on('routeChangeStart', NProgress.start)
    router.events?.on('routeChangeComplete', url => {
      window._hmt?.push(['_trackPageview', url])
      NProgress.done()
    })
    router.events?.on('routeChangeError', NProgress.done)

    return () => {
      router.events?.off('routeChangeStart', () => {})
      router.events?.off('routeChangeComplete', () => {})
      router.events?.off('routeChangeError', () => {})
    }
  }, [router.events])

  useEffect(() => {
    /** 备注：防止邀请码在url切换中丢失，存到cookie和全局store */
    if (store.inviterCode) {
      Cookies.set('inviterCode', store.inviterCode, {
        expires: 365,
      })
    }
  }, [store.inviterCode])
  useEffect(() => {
    if (store.chapterId) {
      Cookies.set(CHAPTER_ID_KEY, store.chapterId, {
        expires: 365,
      })
    }
  }, [store.chapterId])

  return (
    <ApolloProvider client={apolloClient}>
      <ConfigProvider locale={zhCN} autoInsertSpaceInButton={false}>
        <ThemeProvider theme={theme}>
          <MobXProvider store={store}>
            <UserDeviceProvider>
              <Component {...pageProps} />
            </UserDeviceProvider>
          </MobXProvider>
        </ThemeProvider>
      </ConfigProvider>
    </ApolloProvider>
  )
}

export default observer(MyApp)
